import paymentConfig from '../store/_payment';

export const buildCreateCreditCardData = (formData) => {
    let newFormData = {
        CardName: formData.CardName,
        Number: formData.Number,
        ExpiryMonth: formData.ExpiryMonth,
        ExpiryYear: formData.ExpiryYear,
        Token: formData.Token,
        AddressID: Number(formData.AddressID),
        Gateway: paymentConfig.gatewayNames.stripe,
    };

    return newFormData;
};
